import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import SanitizedHTML from './SanitizedHTML';
import DateDisplay from './DateDisplay';
import moment from 'moment';

const ApprovedDetail = ({ step }) => {
  const {
    appointedApprover: { role, faculty, department },
    approver,
    approved,
    comment,
    date,
  } = step;
  const displayFacDept = department
    ? ` - ${department.name}`
    : faculty
    ? ` - ${faculty.name}`
    : '';
  return (
    <Card type="inner" title={step.name}>
      <Descriptions column={2}>
        <Descriptions.Item label="Approver">
          {`${approver?.netId} as ${role?.name}${displayFacDept}`}
        </Descriptions.Item>
        <Descriptions.Item label="Date">
          <DateDisplay date={date} withTime />
        </Descriptions.Item>
        <Descriptions.Item label="Result" span={2}>
          {approved ? 'Approved' : 'Rejected'}
        </Descriptions.Item>
        <Descriptions.Item label="Comments" span={2}>
          <SanitizedHTML dirty={comment || ''} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

ApprovedDetail.propTypes = {
  step: PropTypes.object.isRequired,
};

export default ApprovedDetail;
